export default __webpack_public_path__ + "static/arithmenillustrations-04-03b56098a37bedcd0404cb00d890be68.png";